import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMenu,{attrs:{"open-on-click":"","top":"","transition":"slide-x-transition"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VBtn,_vm._g(_vm._b({attrs:{"color":_vm.iconColor,"icon":"","title":_vm.tooltip}},'v-btn',attrs,false),on),[_c(VIcon,[_vm._v(_vm._s(_vm.openIcon))])],1)]}}])},[_c('div',{staticClass:"dropdown"},[_vm._t("header"),_vm._t("content"),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }